// import React, { useState } from 'react'
// import loginIcons from '../assest/signin.gif'
// import { FaEye } from "react-icons/fa";
// import { FaEyeSlash } from "react-icons/fa";
// import { Link, useNavigate } from 'react-router-dom';
// import imageTobase64 from '../helpers/imageTobase64';
// import SummaryApi from '../common';
// import { toast } from 'react-toastify';

// const SignUp = () => {
//   const [showPassword,setShowPassword] = useState(false)
//   const [showConfirmPassword,setShowConfirmPassword] = useState(false)
//   const [data,setData] = useState({
//       email : "",
//       password : "",
//       name : "",
//       confirmPassword : "",
//       profilePic : "",
//   })
//   const navigate = useNavigate()

//   const handleOnChange = (e) =>{
//       const { name , value } = e.target

//       setData((preve)=>{
//           return{
//               ...preve,
//               [name] : value
//           }
//       })
//   }

//   const handleUploadPic = async(e) =>{
//     const file = e.target.files[0]
    
//     const imagePic = await imageTobase64(file)
    
//     setData((preve)=>{
//       return{
//         ...preve,
//         profilePic : imagePic
//       }
//     })

//   }


//   const handleSubmit = async(e) =>{
//       e.preventDefault()

//       if(data.password === data.confirmPassword){

//         const dataResponse = await fetch(SummaryApi.signUP.url,{
//             method : SummaryApi.signUP.method,
//             credentials: "include",
//             headers : {
//                 "content-type" : "application/json"
//             },
//             body : JSON.stringify(data)
//           })
    
//           const dataApi = await dataResponse.json()

//           if(dataApi.success){
//             toast.success(dataApi.message)
//             navigate("/login")
//           }

//           if(dataApi.error){
//             toast.error(dataApi.message)
//           }
    
//       }else{
//         toast.error("Please check password and confirm password")
//       }

//   }

//   return (
//     <section id='signup'>
//         <div className='mx-auto container p-4'>

//             <div className='bg-white p-5 w-full max-w-sm mx-auto'>

//                     <div className='w-20 h-20 mx-auto relative overflow-hidden rounded-full'>
//                         <div>
//                             <img src={data.profilePic || loginIcons} alt='login icons'/>
//                         </div>
//                         <form>
//                           <label>
//                             <div className='text-xs bg-opacity-80 bg-slate-200 pb-4 pt-2 cursor-pointer text-center absolute bottom-0 w-full'>
//                               Upload  Photo
//                             </div>
//                             <input type='file' className='hidden' onChange={handleUploadPic}/>
//                           </label>
//                         </form>
//                     </div>

//                     <form className='pt-6 flex flex-col gap-2' onSubmit={handleSubmit}>
//                       <div className='grid'>
//                               <label>Name : </label>
//                               <div className='bg-slate-100 p-2'>
//                                   <input 
//                                       type='text' 
//                                       placeholder='enter your name' 
//                                       name='name'
//                                       value={data.name}
//                                       onChange={handleOnChange}
//                                       required
//                                       className='w-full h-full outline-none bg-transparent'/>
//                               </div>
//                           </div>
//                         <div className='grid'>
//                             <label>Email : </label>
//                             <div className='bg-slate-100 p-2'>
//                                 <input 
//                                     type='email' 
//                                     placeholder='enter email' 
//                                     name='email'
//                                     value={data.email}
//                                     onChange={handleOnChange}
//                                     required
//                                     className='w-full h-full outline-none bg-transparent'/>
//                             </div>
//                         </div>

//                         <div>
//                             <label>Password : </label>
//                             <div className='bg-slate-100 p-2 flex'>
//                                 <input 
//                                     type={showPassword ? "text" : "password"} 
//                                     placeholder='enter password'
//                                     value={data.password}
//                                     name='password' 
//                                     onChange={handleOnChange}
//                                     required
//                                     className='w-full h-full outline-none bg-transparent'/>
//                                 <div className='cursor-pointer text-xl' onClick={()=>setShowPassword((preve)=>!preve)}>
//                                     <span>
//                                         {
//                                             showPassword ? (
//                                                 <FaEyeSlash/>
//                                             )
//                                             :
//                                             (
//                                                 <FaEye/>
//                                             )
//                                         }
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>

//                         <div>
//                             <label>Confirm Password : </label>
//                             <div className='bg-slate-100 p-2 flex'>
//                                 <input 
//                                     type={showConfirmPassword ? "text" : "password"} 
//                                     placeholder='enter confirm password'
//                                     value={data.confirmPassword}
//                                     name='confirmPassword' 
//                                     onChange={handleOnChange}
//                                     required
//                                     className='w-full h-full outline-none bg-transparent'/>

//                                 <div className='cursor-pointer text-xl' onClick={()=>setShowConfirmPassword((preve)=>!preve)}>
//                                     <span>
//                                         {
//                                             showConfirmPassword ? (
//                                                 <FaEyeSlash/>
//                                             )
//                                             :
//                                             (
//                                                 <FaEye/>
//                                             )
//                                         }
//                                     </span>
//                                 </div>
//                             </div>
//                         </div>

//                         <button className='bg-red-600 hover:bg-red-700 text-white px-6 py-2 w-full max-w-[150px] rounded-full hover:scale-110 transition-all mx-auto block mt-6'>Sign Up</button>

//                     </form>

//                     <p className='my-5'>Already have account ? <Link to={"/login"} className=' text-red-600 hover:text-red-700 hover:underline'>Login</Link></p>
//             </div>


//         </div>
//     </section>
//   )
// }

// export default SignUp
import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import imageTobase64 from "../helpers/imageTobase64";
import SummaryApi from "../common";
import { toast } from "react-toastify";
import { motion } from "framer-motion";

const SignUp = () => {

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [data, setData] = useState({
    email: "",
    password: "",
    name: "",
    confirmPassword: "",
    profilePic: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUploadPic = async (e) => {
    const file = e.target.files[0];
    const imagePic = await imageTobase64(file);

    setData((prev) => ({
      ...prev,
      profilePic: imagePic,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (data.password === data.confirmPassword) {

      const res = await fetch(SummaryApi.signUP.url, {
        method: SummaryApi.signUP.method,
        credentials: "include",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(data),
      });

      const result = await res.json();

      if (result.success) {
        toast.success("Account Created 🚀");
        navigate("/login");
      } else {
        toast.error(result.message);
      }

    } else {
      toast.error("Passwords do not match ❌");
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1e1b4b] via-[#6d28d9] to-[#9333ea] px-4">

      <div className="w-full max-w-4xl bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col md:flex-row">

        {/* 🔥 LEFT PANEL */}
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          className="w-full md:w-1/2 bg-gradient-to-br from-purple-600 to-indigo-600 text-white flex flex-col justify-center items-center p-8"
        >
          <h2 className="text-3xl font-bold mb-3">
            Join Us 🚀
          </h2>

          <p className="text-sm mb-6 text-center">
            Already have an account?
          </p>

          <Link
            to="/login"
            className="border px-6 py-2 rounded-full hover:bg-white hover:text-purple-600 transition"
          >
            Login
          </Link>
        </motion.div>

        {/* 🔥 FORM */}
        <motion.div
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          className="w-full md:w-1/2 p-8 flex items-center justify-center"
        >

          <form onSubmit={handleSubmit} className="w-full max-w-sm">

            <h2 className="text-2xl font-bold mb-6 text-center">
              Create Account
            </h2>

            {/* PROFILE PIC */}
            <div className="w-20 h-20 mx-auto mb-4 relative">
              <img
                src={data.profilePic || "https://cdn-icons-png.flaticon.com/512/3135/3135715.png"}
                className="w-full h-full rounded-full object-cover border"
              />

              <label className="absolute bottom-0 w-full text-xs bg-black/60 text-white text-center cursor-pointer rounded-b-full">
                Upload
                <input type="file" className="hidden" onChange={handleUploadPic} />
              </label>
            </div>

            {/* NAME */}
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={data.name}
              onChange={handleChange}
              className="w-full p-3 mb-3 border rounded-lg focus:ring-2 focus:ring-purple-500"
            />

            {/* EMAIL */}
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={data.email}
              onChange={handleChange}
              className="w-full p-3 mb-3 border rounded-lg focus:ring-2 focus:ring-purple-500"
            />

            {/* PASSWORD */}
            <div className="flex items-center border rounded-lg px-3 mb-3">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={data.password}
                onChange={handleChange}
                className="w-full p-3 outline-none"
              />
              <span onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {/* CONFIRM */}
            <div className="flex items-center border rounded-lg px-3 mb-4">
              <input
                type={showConfirmPassword ? "text" : "password"}
                name="confirmPassword"
                placeholder="Confirm Password"
                value={data.confirmPassword}
                onChange={handleChange}
                className="w-full p-3 outline-none"
              />
              <span onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {/* BUTTON */}
            <button className="w-full bg-purple-600 text-white py-3 rounded-lg hover:bg-purple-700 transition">
              Sign Up
            </button>

            {/* MOBILE LOGIN */}
            <p className="text-center mt-4 text-sm md:hidden">
              Already have an account?{" "}
              <Link to="/login" className="text-purple-600 font-medium">
                Login
              </Link>
            </p>

          </form>

        </motion.div>

      </div>

    </section>
  );
};

export default SignUp;